module.exports = __webpack_public_path__ + "img/404-clouds.f69d2f37.png";